import Application from '@app/Application';

import { paths } from './paths';
import Home from '@pages/Home/Home';
import ManualSortingPage from '@pages/ManualSorting/ManualSortingPage';
import SortingSettingPage from '@pages/SortingSetting/SortingSettingPage';
import ConsolidatorTrackingPage from '@pages/Consolidator/ConsolidatorTrackingPage';
import ShipmentPage from '@pages/Shipment/ShipmentPage';
import ParcelPage from '@pages/Parcel/ParcelPage';
import SortingTapeBagsPage from '@pages/SortingTapeBags/SortingTapeBagsPage';
import BigsPage from '@pages/Bigs/BigsPage';
import { RequireAuth } from '@shared/utils/auth';
import { Credential } from '@shared/types/api';
import LabelRepairPage from '@pages/LabelRepair/LabelRepairPage';
import WbBagsLabelPage from '@pages/WbBagsLabel/WbBagsLabelPage';
import AzLabelPage from '@pages/AzLabel/AzLabelPage';
import GeLabelPage from '@pages/GeLabel/GeLabelPage';
import ParcelLabelPage from '@pages/ParcelLabel/ParcelLabelPage';
import ManifestAcceptancePage from '@pages/ManifestAcceptance/ManifestAcceptancePage';
import WeightCheckPage from '@pages/WeightCheck/WeightCheckPage';

const routesConfig = [
  {
    path: '/',
    element: <Application />,
    children: [
      {
        index: true,
        element: <Home />,
      },

      {
        path: paths.bags,
        element: <ManualSortingPage />,
        children: [],
      },
      {
        path: paths.sortingSettings,
         element: (
          <RequireAuth role={Credential.chuteSettings}>
           <SortingSettingPage />
          </RequireAuth>
        ),
        children: [],
      },
      {
        path: paths.consolidator,
        element: <ConsolidatorTrackingPage />,
        children: [],
      },
      {
        path: paths.shipment,
        element: <ShipmentPage />,
        children: [],
      },
      {
        path: paths.manifestAcceptance,
        element: <ManifestAcceptancePage />,
        children: [],
      },
      {
        path: paths.parcels,
        element: <ParcelPage />,
        children: [],
      },
      {
        path: paths.sortingTapeBags,
        element: <SortingTapeBagsPage />,
        children: [],
      },
      {
        path: paths.bigs,
        element: <BigsPage />,
        children: [],
      },
      {
        path: paths.labels,
        element: <Home />,
      },
      {
        path: paths.labelRepair,
        element: <LabelRepairPage />,
        children: [],
      },
      {
        path: paths.weightCheck,
        element: <WeightCheckPage />,
        children: [],
      },
      {
        path: paths.wbBagsLabel,
        element: <WbBagsLabelPage />,
        children: [],
      },
      {
        path: paths.azLabel,
        element: <AzLabelPage />,
        children: [],
      },
      {
        path: paths.geLabel,
        element: <GeLabelPage />,
        children: [],
      },
      {
        path: paths.parcelLabel,
        element: <ParcelLabelPage />,
        children: [],
      },
    ],
  },
];

export default routesConfig;
